// 曝光导航 - 首页静态内容数据

export const navItems = [
  { key: "home", label: "首页", href: "#home" },
  { key: "entries", label: "快速入口", href: "#entries" },
  { key: "sources", label: "投稿与来源", href: "#sources" },
  { key: "process", label: "征集流程", href: "#process" },
  { key: "insider", label: "知情者通道", href: "#insider" },
  { key: "about", label: "关于我们", href: "#about" },
  { key: "faq", label: "常见问题", href: "#faq" },
  { key: "contact", label: "提交线索", href: "#contact" },
];

export const heroStats = [
  { value: "6", label: "大类公开入口" },
  { value: "24h", label: "工作日快速回执" },
  { value: "100%", label: "来源保密承诺" },
];

export const quickEntries = [
  {
    id: "baoliao",
    icon: "ri-flashlight-fill",
    title: "爆料入口",
    desc: "面向掌握公开事实线索的内容提供者，集中汇总事件素材与关键证据的提交路径。",
    tag: "素材提交",
  },
  {
    id: "tougao",
    icon: "ri-mail-send-fill",
    title: "投稿渠道",
    desc: "面向独立作者与内容创作者，提供图文、视频等形式的投稿与收录通道。",
    tag: "图文视频",
  },
  {
    id: "source",
    icon: "ri-folder-shield-fill",
    title: "信息来源",
    desc: "汇聚权威公告、公开记录与可核验资料库，帮助信息使用方交叉比对。",
    tag: "资料库",
  },
  {
    id: "xiansuo",
    icon: "ri-search-eye-fill",
    title: "线索征集",
    desc: "围绕热点议题征集可核验线索，由编辑团队统一整理、去重与初筛。",
    tag: "议题征集",
  },
  {
    id: "insider",
    icon: "ri-user-heart-fill",
    title: "知情者通道",
    desc: "为不愿公开身份的信息提供方，提供加密、匿名的私密沟通路径。",
    tag: "匿名沟通",
  },
  {
    id: "hezuo",
    icon: "ri-contacts-book-fill",
    title: "合作入口",
    desc: "面向媒体机构、内容团队与版权方，开放转载、联动与联合选题合作。",
    tag: "机构合作",
  },
];

export const sourceChannels = [
  {
    icon: "ri-secure-payment-fill",
    title: "加密直传",
    desc: "通过端到端加密链接上传图文与音视频原件，附件与元数据一并收纳。",
    points: ["单文件上限 2GB", "自动生成回执编号", "不保存云端缓存"],
  },
  {
    icon: "ri-chat-check-fill",
    title: "私密会话",
    desc: "经人工核验身份后开放一对一沟通，适合需要补充说明的动态线索。",
    points: ["身份可分阶段披露", "全程留痕可追溯", "可约定保密范围"],
  },
  {
    icon: "ri-inbox-2-fill",
    title: "公开投稿",
    desc: "面向正式作者开放的作品提交，编辑部按栏目与主题进行内容收录。",
    points: ["选题匹配快速响应", "稿件采用即签约", "署名尊重作者意愿"],
  },
  {
    icon: "ri-file-list-3-fill",
    title: "文献汇编",
    desc: "整合可公开访问的公告、判例与行业记录，供检索与二次核验使用。",
    points: ["标注来源出处", "定期更新版本", "开放索引检索"],
  },
];

export const processSteps = [
  {
    step: "01",
    title: "明确议题与边界",
    desc: "先判断线索是否涉及公共利益与可公开信息，剔除纯隐私与猜测性内容，明确事实主张与证据边界。",
  },
  {
    step: "02",
    title: "整理证据材料",
    desc: "将时间、地点、人物、经过与旁证结构化整理，优先提供可核验的一手材料与原始出处。",
  },
  {
    step: "03",
    title: "选择对口入口",
    desc: "依据内容类型在爆料、投稿、征集等入口中选择最贴合路径，系统自动生成唯一受理编号。",
  },
  {
    step: "04",
    title: "核验与反馈",
    desc: "编辑部依据材料完整度分级处理，核验期间通过约定渠道反馈进度，并给出采用或补充建议。",
  },
];

export const insiderPolicies = [
  {
    icon: "ri-lock-password-fill",
    title: "身份加密存储",
    desc: "身份信息经加密后隔离存放，仅授权编辑在最小范围内可见，不进入公开内容流程。",
  },
  {
    icon: "ri-account-circle-fill",
    title: "分阶段披露",
    desc: "你可在沟通过程中自行决定披露范围，无需一次性提供全部身份与联系方式。",
  },
  {
    icon: "ri-shield-user-fill",
    title: "去识别化处理",
    desc: "进入核验与发布环节时，可对关键信息做去识别化，最大限度降低可关联风险。",
  },
  {
    icon: "ri-scales-3-fill",
    title: "合规底线先行",
    desc: "所有线索均需通过事实与法律双重把关，涉嫌诽谤、侵害隐私或违法内容一律不予受理。",
  },
];

export const principles = [
  "事实优先：坚持证据链完整、出处可溯，不轻信单方陈述",
  "核验前置：发布前完成交叉比对与利益相关方核验",
  "隐私审慎：不披露与议题无关的个人敏感信息",
  "及时更正：一经发现偏差即发布更正与说明",
  "渠道畅通：为不同对象保留对等回应的机会",
  "版权清晰：严格遵循授权与署名约定",
];

export const testimonials = [
  {
    quote: "上传整套材料后约一个工作日即收到受理回执，编辑全程确认了我希望匿名的诉求，沟通很克制、专业。",
    name: "某公益事件跟进者",
    role: "线索提供人",
  },
  {
    quote: "通过公开投稿渠道提交了两篇分析稿，选题对口的编辑反馈很快，署名方式也完全尊重作者意见。",
    name: "独立撰稿人 陈默",
    role: "投稿作者",
  },
  {
    quote: "最看重的是核验流程。他们要求补齐来源并反复比对，这种审慎让成品经得起推敲。",
    name: "媒体从业者 阿岚",
    role: "合作编辑",
  },
];

export const faqItems = [
  {
    q: "投稿是否必须实名？",
    a: "不必。你可以根据自身风险判断选择匿名或分阶段披露。匿名材料同样会进入核验流程，但完整度不足的匿名线索可能需要补充沟通才能进入下一步。",
  },
  {
    q: "提交后多久会收到反馈？",
    a: "材料完整、路径对口的线索，我们通常在工作日 24 小时内给出受理回执；涉及多来源交叉核验的议题，处理周期会相应延长，期间会通过约定渠道同步进度。",
  },
  {
    q: "哪些内容不会被受理？",
    a: "涉嫌诽谤、捏造、侵害他人隐私或违反法律法规的内容一律不予受理。纯猜测、明显情绪化或缺乏基本证据支撑的材料，编辑部会予以退回并说明原因。",
  },
  {
    q: "如何保证来源不被泄露？",
    a: "身份信息采用加密隔离存储，仅授权编辑在最小范围内可见；进入核验或发布环节前，可就关键信息做去识别化处理，并在你有需要时约定更严格的保密范围。",
  },
  {
    q: "提交的材料会不会被直接公开？",
    a: "不会。所有材料先进入内部核验，是否采用、采用哪些部分、是否做去识别化，均会与你确认。未获授权的内容不会对外发布。",
  },
  {
    q: "机构如何开展转载或选题合作？",
    a: "可在合作入口留下机构与选题方向，编辑会在一周内评估并回函。合作遵循授权清晰、署名明确、对等回应的原则。",
  },
];

export const cooperationTypes = [
  {
    icon: "ri-exchange-funds-fill",
    title: "内容转载",
    desc: "机构号与媒体转载合作，按协议约定授权范围、署名与时效。",
  },
  {
    icon: "ri-layout-masonry-fill",
    title: "联合选题",
    desc: "围绕公共议题联合策划与协作，共同投入采编与核验资源。",
  },
  {
    icon: "ri-team-fill",
    title: "内容共建",
    desc: "与独立作者、行业专家共建栏目，为持续输出提供稳定支持。",
  },
];

export const entryCategories = [
  { label: "事件类", count: "12", note: "已收录公开入口" },
  { label: "行业类", count: "18", note: "跨领域选题覆盖" },
  { label: "地区类", count: "9", note: "分区域线索通道" },
];

export const formPurposeNote =
  "提交后即视为你已知晓并同意：材料将仅用于内部核验与编辑判断，未获授权不予公开；请勿提交与议题无关的他人隐私信息。";